import { ExternalApiConfig, FeatureState, InternalApiConfig, OutlawCoreConfig } from '../types';

export function buildConfig(config: OutlawCoreConfig): OutlawCoreConfig {
  const internalApiConfig = buildInternalApiConfig(config.api?.baseUrl || '/api');

  const externalApiConfig = buildExternalApiConfig(config.externalApi || {});

  return {
    ...config,
    api: { ...internalApiConfig, ...config.api },
    externalApi: { ...externalApiConfig },
    passportUrl: config.passportUrl || 'https://passport.maji.la/auth/login',
    profileUrl: config.profileUrl || 'https://passport.maji.la/auto_signin',
    features: {
      passportFlow: config.features?.passportFlow || FeatureState.disabled,
    },
    baseUrl: config.baseUrl || '',
    production: config.production ?? true,
  };
}

function buildInternalApiConfig(baseUrl: string): InternalApiConfig {
  return {
    rootUrl: '',
    baseUrl,
    authUrl: `${baseUrl}/auth`,
    clientUrl: `${baseUrl}/client`,
    sharingUrl: `${baseUrl}/sharing`,
    videoUrl: `${baseUrl}/client/video`,
    externalUrl: `${baseUrl}/external`,
    playlistUrl: `${baseUrl}/client/playlist`,
    creatorUrl: `${baseUrl}/client/creator`,
    competitionUrl: `${baseUrl}/client/competitions`,
    nftinemaUrl: `${baseUrl}/client/nftinema_wallet`,
    channelUrl: `${baseUrl}/client/channel`,
    filmmakerUrl: `${baseUrl}/client/filmmaker`,
    followerUrl: `${baseUrl}/client/follower`,
    followUrl: `${baseUrl}/client/follow`,
    socialAuthUrl: '/social_auth',
    communityUrl: `${baseUrl}/client/community`,
    usersUrl: `${baseUrl}/users`,
    postUrl: `${baseUrl}/posts`,
    configurationUrl: `${baseUrl}/configurations`,
  };
}

function buildExternalApiConfig(externalApiConfig: Partial<ExternalApiConfig>): ExternalApiConfig {
  return {
    ...externalApiConfig,
    passportUrl: externalApiConfig.passportUrl || 'https://passport-api.maji.la',
    connectedServiceUrls: externalApiConfig.connectedServiceUrls || [],
  };
}
